import FavouriteIcon from "@/assets/images/icons/favourite.svg?inline";
import CloseIcon from "@/assets/images/icons/close.svg?inline";

import { mapGetters } from "vuex";

import { required, email } from "vuelidate/lib/validators";

import {
  ADD_TO_INTERESTING,
  DELETE_FROM_INTERESTING,
  ADD_TO_INTERESTING_WITH_MSG,
  ADD_TO_INTERESTING_WITH_MSG_NO_USER
} from "./gql/InterestingQueries";

export default {
  name: "interesting-control",

  data() {
    return {
      submitLoading: false,

      isShowModal: false,
      loadingContactForm: false,

      name: "",
      phone: "",
      email: "",
      message: "",
      notification: false
    };
  },

  props: {
    propertyId: {
      type: String
    },

    propertyAddress: {
      type: String,
      default: ""
    },

    isInteresting: {
      type: Boolean,
      default: false
    },

    isContactAgent: {
      type: Boolean,
      default: false
    },

    isMobileOffer: {
      type: Boolean,
      default: false
    }
  },

  validations() {
    let params = {
      name: {
        required
      },

      phone: {
        required
      },

      email: {
        email
      }

      // agree: {
      //   required
      // }
    };

    return params;
  },

  mounted() {
    this.name = this.currentUser.fullName;
    this.phone = this.currentUser.phone;
    this.email = this.currentUser.email;

    let href = this.$router.resolve({
      name: "property",
      params: { id: this.propertyId }
    }).href;

    this.message = `I am interested in ${process.env.VUE_APP_BASE_URL}${href}`;
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    buttonClass() {
      let cssClass = "toggle-favourite";
      if (this.isContactAgent) {
        cssClass = `btn btn-md ${
          this.isInteresting ? "btn-success" : "btn-success"
        }`;
      }

      return cssClass;
    }
  },

  methods: {
    clickInterested() {
      if (this.isContactAgent) {
        this.showModal();
      } else {
        this.toggleFavourite();
      }
    },

    toggleFavourite() {
      this.submitLoading = true;

      let query = this.isInteresting
        ? DELETE_FROM_INTERESTING
        : ADD_TO_INTERESTING;

      this.$apollo
        .mutate({
          mutation: query,
          variables: {
            propertyId: this.propertyId
          }
        })
        .then(({ data }) => {
          let message = "";
          let href = this.$router.resolve({
            name: "public_user_profile",
            params: { id: this.currentUser.id }
          }).href;

          if (this.isInteresting) {
            // REMOVE TO INTERESTING
            if (data.deleteInterestingProperty.status == 200) {
              message = `<div>Removed from your interested homes. View interested homes&nbsp;<a href="${href}">here</a>.<div>`;
            }
          } else {
            // ADD TO INTERESTING
            if (data.createInterestingProperty.status == 200) {
              message = `<div>Added to your interested homes. View interested homes&nbsp;<a href="${href}">here</a>.<div>`;
            }
          }

          let toast = this.$toasted.success(message);

          toast.el.getElementsByTagName("a")[0].addEventListener("click", e => {
            e.preventDefault();

            this.$router.push({
              name: "public_user_profile",
              params: { id: this.currentUser.id }
            });

            this.$toasted.clear();
          });

          this.$emit("updatePropertyInteresting", !this.isInteresting);
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },

    submitContactForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.loadingContactForm = true;

        this.$apollo
          .mutate({
            mutation: this.currentUser.id ? ADD_TO_INTERESTING_WITH_MSG : ADD_TO_INTERESTING_WITH_MSG_NO_USER,
            variables: {
              propertyId: this.propertyId,
              name: this.name,
              phone: this.phone,
              email: this.email,
              message: this.message
            }
          })
          .then(({ data }) => {
            let message = "";
            let href = this.$router.resolve({
              name: "public_user_profile",
              params: { id: this.currentUser.id }
            }).href;

            // ADD TO INTERESTING
            if (data.createInterestingPropertyWithMessage.status == 200) {
              message = `<div>Added to your interested homes. View interested homes&nbsp;<a href="${href}">here</a>.<div>`;
            }

            let toast = this.$toasted.success(message);

            toast.el
              .getElementsByTagName("a")[0]
              .addEventListener("click", e => {
                e.preventDefault();

                this.$router.push({
                  name: "public_user_profile",
                  params: { id: this.currentUser.id }
                });

                this.$toasted.clear();
              });

            this.$emit("updatePropertyInteresting", true);
          })
          .catch(mutationError => {
            const errors = mutationError.graphQLErrors;

            for (let error in errors) {
              this.$toasted.error(errors[error].message);
            }
          })
          .finally(() => {
            this.hideModal();
            this.loadingContactForm = false;
          });
      }
    },

    showModal() {
      this.$refs.modalContactAgent.show();
    },

    hideModal() {
      this.$refs.modalContactAgent.hide();
    }
  },

  components: {
    FavouriteIcon,
    CloseIcon
  }
};
